<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>购买会员</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :model="model" :rules="rules" label-width="100px">
        <el-form-item label="手机：">
          <span class="input-width" v-text="model.phone"></span>
        </el-form-item>
        <!-- <el-form-item label="会员号：" prop="memberCardNumber">
          <el-input placeholder="请输入会员号" maxlength="15" v-model="model.memberCardNumber" class="input-width"></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4">
          <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="saveChanges">确认购买</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small {
  min-height: 240px;
  padding: 50px;
}

.el-form-item {
  span {
    height: 40px;
    line-height: 40px;
  }
}

.el-col {
  button {
    line-height: 8px;
    margin-top: 5px;
    margin-left: 10px;
  }
}
</style>

<script>
import { buyMemberCard } from "../../service/student.service";

export default {
  props: {
    dataIn: {
      type: Object,
      required: true
    }
  },
  data() {
    let validateVIPCardNumber = (rule, value, callback) => {
      let message = "";
      let pattern = /^[0-9]*$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "会员号必须为数字值";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      submitBtnDisable: false,
      submitBtnClass: "primary",
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function() {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        }
      },
      showError: false,
      errorMessage: "",
      model: this.initModel(),
      rules: {
        memberCardNumber: [
          {
            required: true,
            message: "会员号不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: validateVIPCardNumber,
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadData();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    initModel() {
      let newModel = {
        phone: "",
        memberCardNumber: ""
      };

      return newModel;
    },
    checkAllInputs() {
      let isValid = true;

      let $ref = this.$refs["model"];
      if (!!$ref) {
        $ref.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    loadData(phone) {
      if (!phone) {
        phone = !!this.dataIn ? this.dataIn.phone : "";
      }

      this.model = this.initModel();
      this.model.phone = phone;
      this.model.memberCardNumber = phone;
    },
    reset() {
      this.loadData();
    },
    saveChanges() {
      if (this.submitBtnStatus.status) {
        this.submitBtnStatus.status = false;

        let isValid = this.checkAllInputs();
        if (!isValid) return;

        this.submitBtnDisable = true;
        this.$message({
          message: "购买成功",
          type: "success"
        });
        this.showError = false;
        this.triggerSaveSuccess();
        this.triggerClose();
        this.submitBtnDisable = false;
      }

      this.submitBtnStatus.resetStatus();
    },
    triggerSaveSuccess(dataOut) {
      if (!dataOut)
        dataOut = {
          phone: this.model.phone,
          memberCardNumber: this.model.memberCardNumber
        };

      this.$emit("saveSuccess", dataOut);
    },
    triggerClose() {
      this.$emit("closeDialog");
    }
  },
  watch: {
    dataIn:function(){
      this.loadData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/buyMemberCardEditor.vue